import React from 'react';
import { Grid } from '@mui/material';
import { Paths } from 'type-fest';
import { useFormState } from 'react-final-form';

import { InfoBox, Typography } from '@occc/ui-design-system';
import { KeyboardDatePicker, KeyboardTimePicker } from '@occc-app/design-system';
import { readableTimezone } from '@occc-app/lib/format';

import { ScheduleFormValues } from './schedule-date-picker.types';
import { isOutsideBusinessHours } from './schedule-date-picker.utils';

const Timezone = () => {
  return (
    <InfoBox>
      <Typography>Time zone is set to {`${readableTimezone()}`}</Typography>
    </InfoBox>
  );
};

const defaultTimeSteps = { minutes: 1 };

export const ScheduleDatePicker = () => {
  const { values } = useFormState<ScheduleFormValues>();
  const showWarning = isOutsideBusinessHours(values.publishAtDate, values.publishAtTime);

  return (
    <Grid container item xs={12} spacing={3}>
      <Grid item xs={12} sm={6} md={3}>
        <KeyboardDatePicker
          label='Date'
          name={'publishAtDate' satisfies Paths<ScheduleFormValues>}
          disablePast
        />
      </Grid>

      <Grid item xs={12} sm={6} md={3}>
        <KeyboardTimePicker
          label='Time'
          name={'publishAtTime' satisfies Paths<ScheduleFormValues>}
          ampm
          timeSteps={defaultTimeSteps}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Timezone />
      </Grid>
      {showWarning && (
        <Grid item xs={12}>
          <InfoBox type='warning'>
            <Typography color='error.dark' variant='body2'>
              This message is scheduled to be sent outside of business hours (8 a.m. to 9 p.m.)
            </Typography>
          </InfoBox>
        </Grid>
      )}
    </Grid>
  );
};
